import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=5f8b2cbf&scoped=true&lang=true&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b2cbf",
  null
  
)

export default component.exports